export function toAllah(verse: string): string {
  const verseOut = verse
    .replace(/God/g, "Allah")
    .replace(/One Allah/g, "One God")
    .replace(/one Allah/g, "one God")
    .replace(/Your Allah/g, "Your God")
    .replace(/your Allah/g, "your God")
    .replace(/The Allah/g, "The God")
    .replace(/the Allah/g, "the God")
    .replace(/Our Allah/g, "Our God")
    .replace(/our Allah/g, "our God")
    .replace(/No Allah/g, "No God")
    .replace(/no Allah/g, "no God")
    .replace(/Good Allah/g, "Good God")
    .replace(/good Allah/g, "good God")
    .replace(/Sole Allah/g, "Sole God")
    .replace(/sole Allah/g, "sole God")
    .replace(/only Allah/g, "only God")
    .replace(/the one God sent/g, "the one Allah sent")
    .replace(/the one God has sent/g, "the one Allah has sent");
  return verseOut;
}
